// @flow

export type SortDirection = 'asc' | 'desc';
export type SortType = 'string' | 'number';

export type CompareProperty = string;
/**
 * @TODO Fix the types of the method underneath
 *
 * Things tried:
 * * checking with typeof (string or number)
 * * separate methods (compareString, compareNumber)
 *
 * https://github.com/facebook/flow/issues/5076
 */
const compare = (a: any, b: any, direction: SortDirection) => {
  switch (direction) {
    case 'asc': {
      if (a < b) {
        return -1;
      }
      if (a > b) {
        return 1;
      }
      break;
    }
    case 'desc': {
      if (b < a) {
        return -1;
      }
      if (b > a) {
        return 1;
      }
      break;
    }
    default:
      return 0;
  }
  return 0;
};

export default compare;
